import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  return auth.loadCurrentUser().pipe(
    map(() => (auth.hasAccess() ? true : router.createUrlTree(['/access-denied']))),
    catchError((error) => {
      if (error?.status === 401) {
        auth.redirectToLogin();
        return of(false);
      }
      router.navigate(['/access-denied']);
      return of(false);
    }),
  );
};
